module.exports = __webpack_public_path__ + "static/img/90-1.bfec3fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/90-1.jpg
// module id = pS8F
// module chunks = 0